import api from './client';

// Orgasm Bank API (Spec 068)
export const orgasmBankAPI = {
  // Feature check
  checkEnabled: () => api.get('/orgasm-bank/enabled'),

  // Balance
  getBalance: (params?: { recipientId?: string; grantorId?: string }) =>
    api.get('/orgasm-bank/balance', { params }),
  getGrantedBalances: () => api.get('/orgasm-bank/balances/granted'),

  // Transactions
  getTransactions: (params?: {
    asGrantor?: boolean;
    grantorId?: string;
    recipientId?: string;
    limit?: number;
    offset?: number;
  }) => api.get('/orgasm-bank/transactions', { params }),

  // Operations
  deposit: (data: { recipientId: string; amount: number; note?: string }) =>
    api.post('/orgasm-bank/deposit', data),
  redeem: (data: { grantorId: string; amount: number; note?: string }) =>
    api.post('/orgasm-bank/redeem', data),
  revoke: (data: { recipientId: string; amount: number; reason: string }) =>
    api.post('/orgasm-bank/revoke', data),

  // Settings
  getSettings: () => api.get('/orgasm-bank/settings'),
  updateSettings: (data: { expirationDays: number | null }) =>
    api.put('/orgasm-bank/settings', data),
};
